// Client/client-vite/src/layouts/RootLayout.tsx
import { Outlet } from "react-router-dom";
import SocketStatus from "@/components/Sockets/SocketStatus";
import { usePresence } from "@/hooks/usePresence";
// import PublicNavbar from "@/components/Navbars/PublicNavbar";
import PublicFooter from "@/components/Footers/PublicFooter";
import { SidebarProvider } from "@/components/ui/sidebar";
import PublicSidebar from "@/components/Sidebars";
import { cookie, COOKIE_KEYS } from "@/lib/cookies";
import * as React from "react";
import MainNavbar from "@/components/Navbars/MainNavbar";

export default function RootLayout() {
  usePresence();

  const [sidebarOpen, setSidebarOpen] = React.useState<boolean>(false);
  React.useEffect(() => {
    setSidebarOpen(cookie.getBool(COOKIE_KEYS.SIDEBAR_STATE));
  }, []);

  const handleOpenChange = (next: boolean) => {
    setSidebarOpen(next);
    cookie.setBool(COOKIE_KEYS.SIDEBAR_STATE, next);
  };

  return (
    <SidebarProvider
      open={sidebarOpen}
      onOpenChange={handleOpenChange}
      style={
        {
          "--sidebar-width": "16rem",
          "--sidebar-width-mobile": "18rem",
        } as React.CSSProperties
      }
    >
      <div className="flex min-h-screen w-full">
        {/* Sidebar stays on the left */}
        <PublicSidebar />

        {/* Main content column */}
        <div className="flex flex-1 flex-col min-h-screen">
          {/* Navbar pinned to top */}
          
            <MainNavbar />
          

          {/* Main content now grows to fill available height */}
          <main className="flex-1 flex flex-col p-0 mt-15">
            <Outlet />
          </main>

          {/* Footer now sits flush at bottom */}
          <SocketStatus />
          <PublicFooter />
        </div>
      </div>
    </SidebarProvider>
  );
}

